import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
  rootContainer: {
    padding: theme.spacing(3),
    minWidth: 0
  },
  tableTitle: { textAlign: 'right', },
  // Mobile card title: must stay after `tableTitle` so it wins the cascade (same specificity).
  mobileTitle: {
    textAlign: 'left',
    overflowWrap: 'anywhere'
  },
  mobileList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    minWidth: 0,
    padding: theme.spacing(2)
  },
  mobileCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    minWidth: 0,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderColor: theme.palette.border.line
  },
  mobileField: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    minWidth: 0
  },
  mobileLabel: {
    color: theme.palette.primary.light,
    fontWeight: 500,
    overflowWrap: 'anywhere'
  },
  mobileChange: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    minWidth: 0
  },
  mobileControl: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    overflow: 'hidden',
    border: `1px solid ${theme.palette.border.line}`,
    borderRadius: theme.shape.borderRadius,
    '&:focus-within': { borderColor: theme.palette.primary.main },
    '& .MuiInputBase-root': {
      minWidth: 0,
      minHeight: theme.spacing(5)
    },
    // DESIGN.md §9: touch devices (including tablets) get ~44px targets.
    '@media (hover: none) and (pointer: coarse)': { '& .MuiInputBase-root': { minHeight: 44 } }
  },
  didThisChangeColumnInputs: {
    display: 'flex',
    '&>:first-child': { flex: 1 },
    '&>:nth-child(2)': { flex: 5 },
  },
  desc_cell: { marginLeft: theme.spacing(3) },
  underline: {
    fontSize: theme.spacing(2),
    color: theme.palette.primary.light,
    fontWeight: 500,
    paddingLeft: theme.spacing(1),
    '&&&:before': { borderBottom: 'none' },
    '&&:after': { borderBottom: 'none' },
    '&:hover': { background: theme.palette.input.border },
    '& .MuiFilledInput-input': { paddingTop: theme.spacing(2)!, }
  },
  inputClassName: {
    color: theme.palette.primary.darker,
    fontWeight: 500,
    paddingLeft: theme.spacing(1),
    '&&&:before': { borderBottom: 'none' },
    '&&:after': { borderBottom: 'none' },
    '&:hover': { background: theme.palette.input.border },
    width: '100%',
    background: theme.palette.background.default,
  },
  disabledClass: {
    color: theme.palette.primary.darker,
    cursor: 'not-allowed'
  },
}));
